export class Configs {
  static get mainSubDomain() {
    return process.env.REACT_APP_SUB_DOMAIN || '';
  }
  static get isDev() {
    return process.env.NODE_ENV === 'development';
  }
  static get apiUrl() {
    return replaceDomain(process.env.REACT_APP_API_URL || '');
  }
  static get walletApiUrl() {
    return replaceDomain(process.env.REACT_APP_WALLET_API_URL || '');
  }
  static get userApiUrl() {
    return replaceDomain(process.env.REACT_APP_USER_ENDPOINT || '');
  }
  static get hashGameUrl() {
    return replaceDomain(process.env.REACT_APP_HASH_GAME_URL || '');
  }
  static get cryptoGameUrl() {
    return replaceDomain(process.env.REACT_APP_CRYPTO_GAME_URL || '');
  }
  static get boGameUrl() {
    return replaceDomain(process.env.REACT_APP_BO_GAME_URL || '');
  }
}

// input: https://hash-api.cryptogaming.top/api
// current origin: hash.devhost.cc
// output: https://hash-api.devhost.cc/api

// input: https://hash-api.cryptogaming.top/api
// current origin: unstable-hash.devhost.cc
// output: https://unstable-hash-api.devhost.cc/api

// input: https://hash-api.cryptogaming.top/api
// current origin: hash-unstable.devhost.cc
// output: https://hash-api-unstable.devhost.cc/api

export const replaceDomain = (url: string) => {
  if (Configs.isDev) return url;
  const parentDomain = getParentDomain();
  const subDomain = getSubDomain(url);

  const domain = `${subDomain}.${parentDomain}`;
  const parsedUrl = new URL(url);
  parsedUrl.hostname = domain;
  return parsedUrl.toString();
};

function getParentDomain() {
  const hostname = window.location.hostname;
  const paths = hostname.split('.');
  if (paths.length <= 2) return hostname;
  paths.shift();
  return paths.join('.');
}
function getSubDomain(url: string) {
  const parsedUrl = new URL(url);
  const hostname = parsedUrl.hostname;
  const paths = hostname.split('.');
  const _paths = location.hostname.split('.');
  if (_paths.length <= 2 || !_paths[0].includes(Configs.mainSubDomain)) return paths[0];
  return _paths[0].split(Configs.mainSubDomain).join(paths[0]);
}
